{
  "level": "abmov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:abmov",
    "objects": "AREAS.E3:abmov.e3",
    "mesh": "TREES.E3:abmov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: podelev2",
      "entity_class": "CSlidingDoor",
      "piece_name": "podelev2",
      "offset": 431,
      "centroid": [
        -3390.0,
        -4984.00048828125,
        1036.45703125
      ],
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1036.20703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1036.70703125
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 20.0,
        "height_z": 0.5,
        "door_width": 20.0,
        "door_depth": 20.0,
        "leaf_depth": 19.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3400.0,
          -4974.00048828125,
          1036.70703125
        ],
        [
          -3380.0,
          -4974.00048828125,
          1036.70703125
        ],
        [
          -3400.0,
          -4994.00048828125,
          1036.70703125
        ],
        [
          -3380.0,
          -4994.00048828125,
          1036.70703125
        ],
        [
          -3400.0,
          -4974.00048828125,
          1036.20703125
        ],
        [
          -3400.0,
          -4994.00048828125,
          1036.20703125
        ],
        [
          -3380.0,
          -4994.00048828125,
          1036.20703125
        ],
        [
          -3380.0,
          -4974.00048828125,
          1036.20703125
        ]
      ],
      "plane_distance": -3400.0,
      "authentic_texture": "baseelev1"
    },
    {
      "tag": "CSlidingDoor piece: podrr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "podrr2",
      "offset": 1524,
      "centroid": [
        -3379.0,
        -4982.00048828125,
        1041.70703125
      ],
      "bbox_min": [
        -3380.0,
        -4984.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4980.00048828125,
        1046.70703125
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 4.0,
        "height_z": 10.0,
        "door_width": 4.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3378.0,
          -4980.00048828125,
          1046.70703125
        ],
        [
          -3378.0,
          -4984.00048828125,
          1046.70703125
        ],
        [
          -3380.0,
          -4980.00048828125,
          1046.70703125
        ],
        [
          -3380.0,
          -4984.00048828125,
          1046.70703125
        ],
        [
          -3380.0,
          -4980.00048828125,
          1036.70703125
        ],
        [
          -3380.0,
          -4984.00048828125,
          1036.70703125
        ],
        [
          -3378.0,
          -4984.00048828125,
          1036.70703125
        ],
        [
          -3378.0,
          -4980.00048828125,
          1036.70703125
        ]
      ],
      "plane_distance": -3380.0,
      "authentic_texture": "cbasedoor1nopad"
    },
    {
      "tag": "CSlidingDoor piece: podrl2",
      "entity_class": "CSlidingDoor",
      "piece_name": "podrl2",
      "offset": 2572,
      "centroid": [
        -3379.0,
        -4985.99951171875,
        1041.70703125
      ],
      "bbox_min": [
        -3380.0,
        -4987.99951171875,
        1036.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4983.99951171875,
        1046.70703125
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 4.0,
        "height_z": 10.0,
        "door_width": 4.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3380.0,
          -4987.99951171875,
          1046.70703125
        ],
        [
          -3380.0,
          -4983.99951171875,
          1046.70703125
        ],
        [
          -3380.0,
          -4983.99951171875,
          1036.70703125
        ],
        [
          -3380.0,
          -4987.99951171875,
          1036.70703125
        ],
        [
          -3378.0,
          -4983.99951171875,
          1046.70703125
        ],
        [
          -3378.0,
          -4983.99951171875,
          1036.70703125
        ],
        [
          -3378.0,
          -4987.99951171875,
          1046.70703125
        ],
        [
          -3378.0,
          -4987.99951171875,
          1036.70703125
        ]
      ],
      "plane_distance": -3380.0,
      "authentic_texture": "cbasedoor1nopad"
    },
    {
      "tag": "CSlidingDoor piece: dbdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "dbdr",
      "offset": 3642,
      "centroid": [
        -3306.5,
        -4972.00048828125,
        1071.2034912109375
      ],
      "bbox_min": [
        -3307.5,
        -4977.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3305.5,
        -4967.00048828125,
        1077.70703125
      ],
      "dimensions_source": {
        "span_x": 2.0,
        "span_y": 10.0,
        "height_z": 13.007080078125,
        "door_width": 10.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3305.5,
          -4967.00048828125,
          1064.699951171875
        ],
        [
          -3305.5,
          -4967.00048828125,
          1077.70703125
        ],
        [
          -3307.5,
          -4967.00048828125,
          1077.70703125
        ],
        [
          -3307.5,
          -4967.00048828125,
          1064.699951171875
        ],
        [
          -3307.5,
          -4977.00048828125,
          1077.70703125
        ],
        [
          -3305.5,
          -4977.00048828125,
          1077.70703125
        ],
        [
          -3305.5,
          -4977.00048828125,
          1064.699951171875
        ],
        [
          -3307.5,
          -4977.00048828125,
          1064.699951171875
        ]
      ],
      "plane_distance": -3307.5,
      "authentic_texture": "cbasedoor1"
    }
  ],
  "tutorial_messages": []
}